/**
 * Shared constants for the four Object Mode surface operators
 * (Surface Box, Cylinder, Poly, Inset).
 *
 * Each operator used to inline its own copy of these magic numbers under
 * different names (`SURFACE_BOX_EPSILON`, `FOOTPRINT_EPSILON`, etc.); they
 * all had the same values. Centralised here so the four tools share one
 * tunable per concern.
 */

/**
 * Sub-epsilon footprints / heights / segments are misclicks; the
 * confirm path bails (no scene change, no undo) below this threshold.
 */
export const SURFACE_CONFIRM_EPSILON = 1e-5;

/**
 * Threshold below which the live prism / cube / cylinder wireframe
 * preview is hidden in each gizmo's `useFrame`. Smaller than the confirm
 * epsilon so the preview only disappears when the height is essentially
 * zero — it still renders during the slow start of an extrude drag.
 */
export const SURFACE_PREVIEW_HEIGHT_EPSILON = 1e-6;

/**
 * Pointer-down → pointer-move screen-space distance below which the
 * gesture is still considered a click (not a drag). Used by the surface
 * handlers to distinguish a face-pick click from a footprint drag.
 */
export const DRAW_DRAG_THRESHOLD_PX = 4;
